import { Stack, Typography } from "@mui/material";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { ValueTile } from "Components/Shared/ValueTile/ValueTile";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Affiliate.Earnings;

type Props = {
  isLoading: boolean;
  value: string;
  hint: string;
};

export const PayoutTile = ({ isLoading, value, hint }: Props) => {
  const { t } = useResource();

  return (
    <ValueTile
      isLoading={isLoading}
      icon={<AccountBalanceWalletIcon />}
      title={t(RESOURCES.CurrentPayout)}
      value={value}
      explanationHint={
        <Stack gap={4}>
          <Typography fontSize="1rem" color="text.secondary" fontWeight={400}>
            {hint}
          </Typography>
        </Stack>
      }
    />
  );
};
